import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const dailySummaryRoutes = [
  {
    path: '/daily-summary',
    name: Routes.DailySummary,
    component: () => import('@/pages/contexts/portal/daily-summary/Index.vue'),
    meta: {
      pageTitle: 'Daily Summary',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      anyPermissions: [
        AppPermissions.VIEW_DAILY_SUMMARY,
        AppPermissions.SEND_DAILY_SUMMARIES,
      ],
    },
  },
]
